import { Controller } from "@hotwired/stimulus"

// Toggles the recipient checkboxes' visibility based on the selected delivery method
// (Email vs Download) in the invoice CSV export drawer, and makes sure a "Download"
// submission bypasses Turbo Drive so the browser handles the CSV response as a native
// file download instead of Turbo trying to navigate/fetch it.
export default class extends Controller {
  static targets = ["deliveryMethod", "recipients"]

  connect() {
    this.refresh()
    this.deliveryMethodTarget.addEventListener("change", () => this.refresh())
  }

  refresh() {
    const selected = this.deliveryMethodTarget.querySelector("input[name='delivery_method']:checked")
    const isEmail = !selected || selected.value === "email"
    this.recipientsTarget.classList.toggle("hidden", !isEmail)
  }

  beforeSubmit(event) {
    const selected = this.deliveryMethodTarget.querySelector("input[name='delivery_method']:checked")
    if (selected && selected.value === "download") {
      event.target.setAttribute("data-turbo", "false")
    } else {
      event.target.removeAttribute("data-turbo")
    }
  }
}
